export const VALIDATOR_CONSTANTS = {
  DEFAULT_MAX_NUMBER: 9999,
  DEFAULT_HIGH_MAX_NUMBER: 999999,
};
